import config from './config';
import World from './world';
import RigidBody from './body';
import * as shapes from './shapes';
import * as generators from './generators';
import * as constraints from './constraints';

export { config, World, RigidBody, shapes, constraints, generators };
export default { config, World, RigidBody, shapes, constraints, generators };



// WEBPACK FOOTER //
// ./src/physics/index.js